import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    done: 'Done!',
    doneDescription:
      "Your funds delegated and you'll see your first rewards soon.",
    buttonText: 'Perfect!',
  },
};
